module.exports = __webpack_public_path__ + "6b8770c889bd60badc65f839e00b652f.svg";